<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a><span class="bold">BREAKING THE <span class="f1">GERMAN DAMS</span></span></h1>
<p class="subtitle"><span class="bold">A MINUTE-BY-MINUTE ACCOUNT OF <span class="f2">OPERATION ‘CHASTISE’</span> 16–17 MAY 1943</span></p>
<div class="image_container">
<img alt="Image" src="images/logo.jpg"/>
</div>
<p class="author"><span class="bold">Robert Owen</span></p>
<p class="aff">Foreword by</p>
<p class="aff1"><span class="bold">James Holland</span></p>
<div class="image_container">
<img alt="Image" src="images/logo1.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?5e98a1bf